import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { style: {"color":"red"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn_add_icon = _resolveComponent("v-btn-add-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, { "no-gutters": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { class: "d-flex align-center col-auto pr-3" }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, "Tableau d'amortissement (" + _toDisplayString(_ctx.deadlines.length) + " échéances)", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { class: "pl-2 d-flex align-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_divider)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "1",
          class: "pl-2 d-flex align-center justify-end"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn_add_icon, {
              size: "x-small",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.newAmountDue()))
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.errorCount)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0,
          "no-gutters": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { class: "d-flex align-center col-auto" }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_1, "Nombre d'erreur(s) : " + _toDisplayString(_ctx.errorCount), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_col, {
              cols: "2",
              class: "pl-2 d-flex align-center justify-end"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_switch, {
                  "hide-details": "auto",
                  modelValue: _ctx.filterErrors,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterErrors) = $event)),
                  class: "mt-0",
                  label: "Filtrer"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_row, { "no-gutters": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_list, {
              style: {"background-color":"transparent","overflow-y":"auto"},
              width: "100%",
              height: "438"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDeadlines, (deadline) => {
                  return (_openBlock(), _createBlock(_component_v_list_item, {
                    key: deadline.index,
                    class: _normalizeClass(
                        deadline.focus
                            ? 'oss-list-item1-high mb-2'
                            : !deadline.errorCount
                              ? 'oss-list-item1 mb-2'
                              : 'oss-list-item1-error mb-2'
                    ),
                    onClick: _withModifiers(($event: any) => (_ctx.toEditDeadline = deadline), ["stop"]),
                    onMouseover: ($event: any) => (deadline.highlightBT(true, 'svg')),
                    onMouseout: ($event: any) => (deadline.highlightBT(false)),
                    id: 'identified-loan-' + deadline.index,
                    active: false,
                    link: false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "1",
                            class: "d-flex align-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn_icon, {
                                color: "primary",
                                onClick: _withModifiers(($event: any) => (deadline.selected = !deadline.selected), ["stop"]),
                                size: "small",
                                icon: 
                                    deadline.selected ? '$oss-circle-check' : '$oss-circle-uncheck'
                                
                              }, null, 8, ["onClick", "icon"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, {
                            cols: "2",
                            class: "pl-1 d-flex align-center"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                style: _normalizeStyle(deadline.dateStyle)
                              }, _toDisplayString(deadline.formatDate), 5)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, {
                            cols: "2",
                            class: "pl-1 d-flex align-center justify-end"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(_ctx.newCommonFormatCurrency(deadline.capital)), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, {
                            cols: "2",
                            class: "pl-1 d-flex align-center justify-end"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(_ctx.newCommonFormatCurrency(deadline.interests)), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, {
                            cols: "2",
                            class: "pl-1 d-flex align-center justify-end"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(_ctx.newCommonFormatCurrency(deadline.insurance)), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["class", "onClick", "onMouseover", "onMouseout", "id"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}